// import { store } from '../../index';
import { applyMiddleware, createStore } from 'redux';
import ReduxThunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import promiseMiddleware from 'redux-promise';
import { ReduxState } from '../../interfaces';
import reducers from '../../reducers';
import { Action } from '../../models';

export const store = createStore(
  reducers,
  composeWithDevTools(applyMiddleware(...[promiseMiddleware], ReduxThunk))
);

export const getStateFull = (): ReduxState => store.getState();

export const doAction = <T extends {}>(type: string, payload: T) =>
  store.dispatch({ type, payload });

export const doEmptyAction = (type: string) => doAction<any>(type, undefined);

export const dispatch = (action: Action<any>) => store.dispatch(action);
